import React from 'react'
import { useWatch } from 'react-hook-form'
import { ServicesConfig } from 'services/api/entities/servicesconfig'
import { allowedServicesChoices } from 'services/cfg/form'
import KLocalizedSelectArrayInput from 'ui-shared/WrappedInputs/TailoredFilters/KLocalizedSelectArrayInput'

type Props = { source: string; label: string }

const BriefServiceInput: React.FC<Props> = ({ source, label }) => {
  const professionalServices = useWatch<
    ServicesConfig,
    'professionalService.services'
  >({ name: 'professionalService.services' })

  const professionalSectionChoices = professionalServices.map(
    ({ section: { name } }) => ({ id: name, name })
  )

  const serviceChoices = [
    ...allowedServicesChoices,
    ...professionalSectionChoices,
  ]

  return (
    <KLocalizedSelectArrayInput
      source={source}
      label={label}
      choices={serviceChoices}
    />
  )
}

export default BriefServiceInput
